import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

function AutoSubmitForm({ formData = [], targetURL }) {
    const formRef = useRef();
    const csrfToken = Cookies.get('XSRF-TOKEN');

    useEffect(() => {
        formRef.current.submit();
    }, []);

    return (
        <form ref={formRef} method="POST" action={targetURL}>
            <input type="hidden" name="_csrf" value={csrfToken} />
            {formData.map(({ name, value }) => (
                <input type="hidden" key={name} name={name} value={value} />
            ))}
        </form>
    );
}

AutoSubmitForm.propTypes = {
    formData: PropTypes.arrayOf(
        PropTypes.exact({
            name: PropTypes.string,
            value: PropTypes.string,
        }),
    ),
    targetURL: PropTypes.string.isRequired,
};
export default AutoSubmitForm;
